import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/product/ProductCard';
import { Heart, Sparkles, ArrowRight } from 'lucide-react';

const WishlistPage = () => {
  const { wishlist } = useWishlist();
  const navigate = useNavigate();

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 bg-[#FDFBF7]">
      {/* Header Section */}
      <div className="mb-8 sm:mb-10 text-center sm:text-left">
        <div className="inline-flex items-center space-x-1.5 mb-2">
          <Sparkles className="w-3.5 h-3.5 text-[#4A0E17]" />
          <span className="text-[10px] font-serif font-bold tracking-[0.25em] text-[#4A0E17] uppercase">
            Curated Treasures
          </span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-serif font-bold text-[#4A0E17] tracking-tight mb-2">
          Your Saved Favorites
        </h1>
        <p className="text-xs sm:text-sm text-[#7A6B5D] font-light max-w-lg">
          Silk drapes and fine heritage jewelry bookmarked for your special occasions.
        </p>
      </div>

      {/* Empty State vs Products Grid */}
      {wishlist.length === 0 ? (
        <div className="bg-[#FDFBF7] rounded-3xl p-12 sm:p-16 text-center border border-[#E8DFC8] shadow-sm max-w-2xl mx-auto my-6 space-y-5">
          <div className="w-16 h-16 bg-[#F4EFE6] rounded-full flex items-center justify-center mx-auto border border-[#E8DFC8]">
            <Heart className="w-8 h-8 text-[#4A0E17]/60" />
          </div>
          
          <div className="space-y-1">
            <h3 className="text-lg font-serif font-bold text-[#4A0E17]">
              Your Wishlist is Empty
            </h3>
            <p className="text-xs text-[#7A6B5D] font-light max-w-sm mx-auto">
              Explore our handloom pure silk sarees and handcrafted antique jewelry to save your favorite drapes.
            </p>
          </div>

          <button
            onClick={() => navigate('/collections')}
            className="inline-flex items-center space-x-2 bg-[#4A0E17] hover:bg-[#6B1320] text-[#FDFBF7] text-xs font-serif font-bold uppercase tracking-wider px-6 py-3.5 rounded-xl transition-all duration-300 shadow-md active:scale-95 border border-[#6B1320]"
          >
            <span>Explore Collections</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {wishlist.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </main>
  );
};

export default WishlistPage;